import React, { useEffect, useState, useRef } from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import './style.css';
import { parseElementsToString } from '../../modules/quality/ocr/ScannedDocuments/Create/Delivery/formItems';

const AccionaDropdownSelectable = ({ state, label, onChange }) => {
  const intl = useIntl();
  const [active, setActive] = useState('');
  const [block, setBlock] = useState({ display: 'none' });
  const [message, setMessage] = useState('');

  const onOpen = () => {
    if (active === 'active') {
      setActive('');
      setBlock({ display: 'none' });
    } else {
      setActive('active');
      setBlock({ display: 'block', maxHeight: '1000px' });
    }
  };
  let wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setActive('');
        setBlock({ display: 'none' });
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    setMessage(parseElementsToString(state.value, ', '));
  }, [state.value, setMessage]);

  return (
    <div
      className="select"
      ref={wrapperRef}
      style={{ background: 'white', maxHeight: '100%' }}
    >
      <div
        style={{}}
        className={'select-styled button-dropdown ' + active}
        onClick={onOpen}
      >
        <span
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: '92%',
            textOverflow: 'ellipsis',
            display: 'block',
          }}
        >
          {message === '' ? intl.formatMessage({ id: 'notElements' }) : message}
        </span>
      </div>
      <ul
        className="select-options select-opt-timezones"
        id="ul-dropdown"
        style={block}
      >
        {Object.keys(state.value).map((key, index) => (
          <li
            key={`${index}-${key}`}
            id={`${label}`}
            onClick={() => onChange('elements', { [key]: !state.value[key] })}
          >
            <input
              style={{ verticalAlign: 'text-top' }}
              key={`${index}.checkbox.selector`}
              type="Checkbox"
              onChange={() => {}}
              checked={state.value[key]}
            />
            <span style={{ marginLeft: '8px' }}>{key}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

AccionaDropdownSelectable.propTypes = {
  state: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

AccionaDropdownSelectable.defaultProps = {
  onChange: () => {},
};

export default AccionaDropdownSelectable;
